export class FinancialConverterError extends Error {
  constructor(public type: string) {
    super(`Invalid ${type} format`);
    this.name = 'FinancialConverterError';
  }
}
